import { getErrorMessage } from '../../errorBuilder';
import { get, post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getAdminTickets = async (params) => {
  const builder = new UrlBuilder(`/manage/tickets/list-tickets`);
  builder.add('page', params?.page || 1);
  builder.add('pageSize', params?.limit || 10);
  builder.add('ticketType', params?.type);
  builder.add('status', params?.status);
  builder.add('title', params?.search);
  builder.add('startDate', params?.startDate);
  builder.add('endDate', params?.endDate);
  builder.add('clientId', params?.clientId);
  builder.add('userId', params?.userId);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getAllClients = async () => {
  const builder = new UrlBuilder(`/manage/clients/list`);
  builder.add('mode', 'ALL');

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getClientAllUsers = async (payload) => {
  const builder = new UrlBuilder(`/manage/clients/list-users`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
